import { createRequestDataSource } from '@ngneat/elf-requests';
import { selectCurrentPageEntities } from '@ngneat/elf-pagination';

import { accountStore } from './account.store';

export const getAccountDataSource = createRequestDataSource({
  store: accountStore,
  data$: () => accountStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getAccounts',
  dataKey: 'accounts',
});
